module.exports = __webpack_public_path__ + "img/pick4.3052ad6e.png";